import React from "react";
import logo from "../../assets/logo.png";

const Logo = ({ onclick }) => {
  return (
    <>
      <img
        src={logo}
        onClick={onclick}
        height={"40px"}
        width={"200px"}
        alt="TMT Logo"
        style={{ transition: "all 0.5s" }}
      />
    </>
  );
};

export default Logo;
